<template>
  <SoapManager/>
</template>

<script>
import SoapManager from './components/SoapManager.vue'
import './index.css'

export default {
  name: 'App',
  components: {
    SoapManager
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
